/* eslint-disable */


/**
 * Create styles for `<KeyValuePairs />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<KeyValuePairs />` styles
 */
const keyValuePairsStyles = ({ theme }) => ({
  inputRoot: {
    backgroundColor: theme.palette.grey[200],
    minHeight: theme.spacing(1) * 4.5,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
  },
});

export default keyValuePairsStyles;
